/* eslint-disable no-unused-expressions */
import * as Klaro from '../../node_modules/klaro/dist/klaro-no-css';

const config = {
  testing: false,
  elementID: 'klaro',
  storageMethod: 'localStorage',
  storageName: 'klaro',
  htmlTexts: true,
  cookieExpiresAfterDays: 30,
  default: false,
  mustConsent: false,
  acceptAll: true,
  hideDeclineAll: false,
  hideLearnMore: false,
  translations: {
    /*
    The `zz` key contains default translations that will be used as fallback values.
        This can e.g. be useful for defining a fallback privacy policy URL.
    */
    zz: {
      privacyPolicyUrl: '/datenschutz',
    },
    de: {
      privacyPolicyUrl: '/datenschutz',

      consentNotice: {
        description: 'Hallo! Könnten wir bitte zusätzliche Dienste für {purposes} aktivieren? Sie können Ihre Zustimmung später jederzeit ändern oder zurückziehen. Um mehr zu erfahren, lesen Sie bitte unsere {privacyPolicy}.',
        learnMore: 'Einstellungen',
      },
      decline: 'Ablehnen',
      ok: 'Akzeptieren',
      consentModal: {
        title: 'Datenschutzeinstellungen',
        description: 'Wir verwenden Cookies und Drittanbieterdienste, um Ihnen ein möglichst optimales und auf Ihre Bedürfnisse zugeschnittenes ​Erlebnis unseres Onlineangebots zu bieten. '
          + 'Dazu zählen Cookies, die für den reibungslosen und sicheren Betrieb des Onlineangebots notwendig sind, sowie solche die zu statistischen Zwecken verwendet werden um das Onlineangebot für Sie zu optimieren. '
          + 'Sie können selbst entscheiden, welche Dienste Sie erlauben möchten.',
      },
      purposes: {
        thirdparty: {
          title: 'Eingebettete Inhalte',
          description: 'Inhalte und Cookies die von Drittanbietern verwendet werden. Hierzu zählen unter anderem Anbieter von Newsletteranmeldungen.',
        },
        media: {
          title: 'Medienelemente',
          description: 'Cookies die für die Einbettung von Inhalten von Drittanbietern benötigt werden. Hierzu zählen unter anderem Youtube und Vimeo',
        },
        analytics: {
          title: 'Besucher-Statistiken',
          description: 'Diese Dienste verarbeiten personenbezogene Daten, um den von dieser Website angebotenen Service zu optimieren.',
        },
        functional: {
          title: 'System',
          description: 'Dienste die für den Betrieb unserer Website zwingend erforderlich sind.',
        },
      },
    },
    en: {
      privacyPolicyUrl: '/datenschutz',
      consentModal: {
        title: 'Privacy settings',
        description: 'We use cookies and third-party services to provide you with the best possible experience of our online services tailored to your needs. '
          + 'This includes cookies that are necessary for the smooth and secure operation of the online offer, as well as those that are used for statistical purposes to optimise the online offer for you. '
          + 'You can decide for yourself which services you would like to allow.',
      },
      purposes: {
        thirdparty: {
          title: 'Embedded content',
          description: 'Content and cookies used by third-party providers. These include, among others, newsletter subscription providers.',
        },
        media: {
          title: 'Media elements',
          description: 'Cookies that are required for the embedding of content from third-party providers. These include, among others, Youtube and Vimeo.',
        },
        analytics: {
          title: 'Visitors statistics',
          description: 'These services process personal data in order to optimise the service offered by this website.',
        },
        functional: {
          title: 'System',
          description: 'Services that are absolutely necessary for the operation of our website.',
        },
      },
    },
  },
  services: [
    {
      name: 'google-analytics',
      purposes: ['analytics'],
      required: false,
      optOut: false,
      onlyOnce: true,
      translations: {
        zz: {
          title: 'Google Analytics',
        },
        de: {
          title: 'Google Analytics',
          description: 'Google Analytics ist ein Tool, mit dem wir messen können, wie Benutzer mit Website-Inhalten interagieren. Mit diesen Informationen optimieren wir unseren Webauftritt für Sie. Verarbeitung Ihrer Nutzerdaten durch uns.',
        },
        en: {
          title: 'Google Analytics',
          description: 'Google Analytics is a tool that allows us to measure how users interact with website content. We use this information to optimise our website for you. Processing of your user data by us.',
        },
      },
      cookies: [
        [/^_ga$/, '/', '.baral-geohaus.de'],
        [/^_ga(_.*)?/, '/', '.baral-geohaus.de'],
      ],
      elements: null,
    },
    {
      name: 'video',
      translations: {
        zz: {
          title: 'eingebettete Videos',
          description: 'Cookies that are stored by the video platform provider.',
        },
        en: {
          title: 'embedded Videos',
          description: 'Cookies that are stored by the video platform provider.',
        },
        de: {
          title: 'eingebettete Videos',
          description: 'Cookies die vom Anbieter der Videoplatform gespeichert werden.',
        },
      },
      purposes: ['media'],
      optOut: false,

      /*
      [no translation for key annotated-config.services.contextualConsentOnly]
      */
      contextualConsentOnly: false,
    },
    {
      name: 'newsletter',
      purposes: ['thirdparty'],
      optOut: false,
      contextualConsentOnly: true,
      translations: {
        zz: {
          title: 'Newsletter Anmeldung',
          description: 'Scripts and cookies that are needed to display maps and calculate routes.',
        },
        de: {
          title: 'Newsletter Anmeldung',
          description: 'Skripte und Cookies die zur Darstellung von Newsletterinhalten.',

        },
        en: {
          title: 'Newsletter subscription',
          description: 'Scripts and cookies used to display newsletter content.',
        },
      },
    },
    {
      name: 'contao_session',
      translations: {
        zz: {
          title: 'Contao Session',
        },
        en: {
          description: 'Session cookie, in which information about the language you have chosen, the content of your notepad and the status of your request is stored.',
        },
        de: {
          description: 'Sitzungscookie, in im werden Informationen zu der von ihnen gewählten Sprache, dem Inhalt ihres Merkzettels und dem Stand Ihrer Anfrage gespeichert.',
        },
      },
      purposes: ['functional'],
      default: true,
      required: true,
      cookies: [
        'PHPSESSID',
        'csrf_https-contao_csrf_token',
      ],
    },
  ],
};

// we assign the Klaro module to the window, so that we can access it in JS
window.klaro = Klaro;
// we set up Klaro with the config
Klaro.setup(config);

document.addEventListener('DOMContentLoaded', () => {
  const cookieConfig = document.querySelector('main a[href="#Cookie-Einstellungen"]');
  if (cookieConfig) {
    cookieConfig.classList.add('link-button');
    cookieConfig.addEventListener('click', (e) => {
      e.preventDefault;
      Klaro.show();
    });
  }
});
